import React from 'react';
import { TextFieldProps, TextField, makeStyles } from '@material-ui/core';
import classnames from 'classnames';

const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    color: palette.primary.contrastText,
    '& .MuiOutlinedInput-root': {
      '& input': {
        color: palette.primary.contrastText,
      },
      '& fieldset': {
        borderColor: palette.common.white,
        '&:hover:': {
          borderColor: palette.primary.light,
        },
      },
      '&.Mui-focused fieldset': {
        border: `1px ${palette.primary.contrastText} solid`,
      },
    },
    '& .MuiInputLabel-outlined ': {
      color: palette.primary.contrastText,
    },
    '& .MuiFormHelperText-contained': {
      margin: `${spacing(0.5)}px 0 0 0`,
    },
    '& .MuiFormHelperText-root': {
      lineHeight: '16px',
    },
  },
  greenBorder: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'green',
      },
    },
  },
}));

interface CustomTextField {
  valid?: boolean;
  className?: string;
}

export const CustomTextField: React.FunctionComponent<TextFieldProps &
  CustomTextField> = props => {
  const { root, greenBorder } = useStyles();
  const rootClasses = classnames(root, {
    [props.className || '']: props.className,
    [greenBorder]: props.valid,
  });

  return <TextField {...props} variant="outlined" className={rootClasses} />;
};
